import { render } from "./CadastroTransportador.vue?vue&type=template&id=fbeff9c2"
import script from "./CadastroTransportador.vue?vue&type=script&lang=ts"
export * from "./CadastroTransportador.vue?vue&type=script&lang=ts"
script.render = render

export default script